

const initialStates = {
    status: '',
    cart: [''],


}

const mutations = {


    success(state,cart) {

        state.status       = 'success'
        state.cart.push(cart)


    },
    destroy(state,cart) {

        state.status       = 'destroy'

        state.cart.splice(state.cart.indexOf(cart),1)


},
    fail(state) {
        state.status       = 'fail'
    },
}

const getters = {

    status: ({status}) => status,
    cart: ({cart}) => cart,
    count: ({count}) => count,
}

const actions = {

    add({commit},cart) {

            commit('success',cart);
    },
    remove({commit},cart) {

            commit('destroy',cart);
    }


}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}